import { PropsWithChildren } from "react";
import styles from "./FormFieldGrid.module.css";

const FormFieldGrid = ({ children }: PropsWithChildren) => (
  <div className={styles.grid}>{children}</div>
);

export default FormFieldGrid;
